import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme)=>
({
footer: {
    backgroundColor:'#cde9ee',
    //padding: '30px 0',
    // marginTop: '-50px',
    // marginBottom: '-50px',
    //paddingRight: '-3.51rem',
    // marginLeft: '-3.51rem',
    //padding: '25px',
    // border: 'none',
    width:'100%',
    // position:'fixed',
    bottom: '0',
    display:'flex',
    height:'100px',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    overflow:'auto'
    // marginBottom: '-50px',
    // border: 'none',
    
    
}



}));

export default useStyles;